import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import { Link } from 'react-router';

export const AnchorLink = (props) => {
    const {
        className,
        smooth,
        title,
        to,
    } = props;

    const scrollWithOffset = useCallback((el) => {
        const elementPosition = el.offsetTop - 48;

        const isIE11 = Boolean(window.MSInputMethodContext) && Boolean(document.documentMode);
        if (isIE11) {
            window.scrollTo(0, elementPosition);
        } else {
            window.scroll({
                top: elementPosition,
                left: 0,
                behavior: smooth ? 'smooth' : 'auto',
            });
        }
    }, [smooth]);

    const handleClick = useCallback(() => {
        const hash = typeof to === 'string' && to.includes('#') ? to.split('#')[1] : null;
        if (!hash) {
            return;
        }

        // Allow route navigation to settle, then scroll to the hash target.
        requestAnimationFrame(() => {
            const el = document.getElementById(hash);
            if (el) {
                scrollWithOffset(el);
            }
        });
    }, [to, scrollWithOffset]);

    return (
        <Link to={to} className={className} onClick={handleClick}>
            {title}
        </Link>
    );
};

AnchorLink.propTypes = {
    className: PropTypes.string,
    smooth: PropTypes.bool,
    title: PropTypes.node.isRequired,
    to: PropTypes.string.isRequired,
};
